<ion-item button="true">
  <div class="title">
    <div class="kp urigul" [innerHTML]="kpDescription"></div>
    <div class="jp" [innerHTML]="jpDescription"></div>
  </div>
</ion-item>
